import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../Baseurl";

const AllShippingAddress = ({ onAddressSelect }) => {
    const user_id = localStorage.getItem("cust_id");
    const [addresses, setAddresses] = useState([]);
    const [selectedAddressId, setSelectedAddressId] = useState(null);
  
    useEffect(() => {
      if (user_id) {
        fetchAddresses();
      }
    }, [user_id]);
  
    const fetchAddresses = async () => {
      try {
        const res = await axios.get(`${baseurl}getShippingAddressesByUserId/${user_id}`);
        if (res.data.success) {
          setAddresses(res.data.data);
          const defaultAddress = res.data.data.find((addr) => addr.is_default);
          if (defaultAddress) {
            setSelectedAddressId(defaultAddress.id);
            if (onAddressSelect) onAddressSelect(defaultAddress.id);
          }
        }
      } catch (err) {
        console.error("Failed to fetch addresses:", err);
        Swal.fire("Error", "Could not load shipping addresses", "error");
      }
    };
  
    const handleSelect = (id) => {
      setSelectedAddressId(id);
      if (onAddressSelect) onAddressSelect(id);
    };
  
    return (
      <div>
        <h5 className="mb-3">Select a Shipping Address</h5>
        {addresses.length === 0 ? (
          <p>No addresses found. Please add one.</p>
        ) : (
          <div className="list-group text-start">
            {addresses.map((address) => (
              <label key={address.id} className="list-group-item d-flex">
                <input
                  type="radio"
                  name="shippingAddress"
                  value={address.id}
                  checked={selectedAddressId === address.id}
                  onChange={() => handleSelect(address.id)}
                  className="form-check-input me-2"
                />
                <div>
                  <strong>{address.full_name}</strong> ({address.address_type})
                  <br />
                  {address.address_line1}, {address.address_line2 && `${address.address_line2}, `}
                  {address.city}, {address.state} - {address.postal_code}
                  <br />
                  <small>{address.country}</small>
                  {address.is_default && <span className="badge bg-success ms-2">Default</span>}
                </div>
              </label>
            ))}
          </div>
        )}
      </div>
    );
  };
  
  export default AllShippingAddress;
  